import { render, staticRenderFns } from "./forbidden-keyword-actions-column.vue?vue&type=template&id=f487293c"
import script from "./forbidden-keyword-actions-column.vue?vue&type=script&lang=js"
export * from "./forbidden-keyword-actions-column.vue?vue&type=script&lang=js"
import style0 from "./forbidden-keyword-actions-column.vue?vue&type=style&index=0&id=f487293c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports